import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Gallery } from "./components/gallery";
import { Contact } from "./components/contact";
import {
  translations,
  LANGUAGES,
  DEFAULT_LANGUAGE,
} from "./data/translations";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const LANGUAGE_STORAGE_KEY = "language";

const getInitialLanguage = () => {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && LANGUAGES.includes(stored)) return stored;
  } catch (e) {
    // localStorage unavailable (private mode, etc.) — fall back to the default.
  }
  return DEFAULT_LANGUAGE;
};

const App = () => {
  const [language, setLanguage] = useState(getInitialLanguage);

  const changeLanguage = (lang) => {
    if (!LANGUAGES.includes(lang)) return;
    setLanguage(lang);
    try {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    } catch (e) {
      // Ignore persistence failures; the choice still applies for this session.
    }
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const data = translations[language];

  return (
    <div>
      <Navigation
        language={language}
        onLanguageChange={changeLanguage}
        ui={data.ui}
      />
      <Header data={data.Header} gallery={data.Gallery} ui={data.ui} />
      <Features data={data.Features} ui={data.ui} />
      <About data={data.About} ui={data.ui} />
      {/* <Services data={data.Services} /> */}
      <Gallery data={data.Gallery} ui={data.ui} />
      {/* <Testimonials data={data.Testimonials} /> */}
      {/* <Team data={data.Team} /> */}
      <Contact data={data.Contact} ui={data.ui} />
    </div>
  );
};

export default App;
